export default __webpack_public_path__ + "static/media/gen-asset.dae59860.png";